import { render, staticRenderFns } from "./commonDormChart.vue?vue&type=template&id=2ccb1b3b&scoped=true"
import script from "./commonDormChart.vue?vue&type=script&lang=js"
export * from "./commonDormChart.vue?vue&type=script&lang=js"
import style0 from "./commonDormChart.vue?vue&type=style&index=0&id=2ccb1b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb1b3b",
  null
  
)

export default component.exports